import api from '../api';

export default class recadTiposDependentesService {
  constructor() {
    throw 'Não é possível instanciar recadTiposDependentesService';
  }

  static async lista() {
    const endpoint = mergeEndpoint();
    return await api.get(endpoint);
  }
}

const mergeEndpoint = () => {
  return `recadastramento-servidores/tipos-dependentes`;
};



// WEBPACK FOOTER //
// ./src/services/enums/recadTiposDependentesService.js